import * as R from 'ramda';

const customFilterMyfleet = (state: any) => R.pathOr('',  ['customFilterMyfleet'] , state);

const selectors = {
  customFilterMyfleet,
};

export default selectors;
